export class BuzonFilter {
  uniOrganizacional?: string;
  puesto?: string;
  estado?: string;
}
